import { render, staticRenderFns } from "./BubbleTabs.vue?vue&type=template&id=1afe0427&scoped=true&"
import script from "./BubbleTabs.vue?vue&type=script&lang=ts&"
export * from "./BubbleTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BubbleTabs.vue?vue&type=style&index=0&id=1afe0427&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe0427",
  null
  
)

export default component.exports